import {createApi} from '@reduxjs/toolkit/query/react';
import {IArtifact} from 'app/types/Shared';
import {baseQuery} from 'app/helpers/auth';

export const artifactsApi = createApi({
  reducerPath: 'artifactsApi',
  baseQuery,
  tagTypes: ['artifactsApi'],
  endpoints(builder) {
    return {
      getAllArtifacts: builder.query<Array<IArtifact>, void>({
        query: () => {
          return {
            url: `/artifacts`,
            method: 'GET',
          };
        },
      }),
      getMasterSOP: builder.query<IArtifact, void>({
        query: () => {
          return {
            url: `/masterSOP`,
            method: 'GET',
          };
        },
      }),
    };
  },
});

export const {useGetAllArtifactsQuery} = artifactsApi;
